<template>
    <b-modal v-model="isVisible" modal-class="agent-details-modal" centered size="xl" hide-footer no-close-on-backdrop
        hide-header-close @hidden="handleClose" content-class="health-questionnaire-modal">
        <!-- Modal Header -->
        <template #modal-header>
            <div class="view-agent-header d-flex justify-content-center align-items-center">
                <h5 class="modal-title">Health Questionnaires</h5>
                <b-button variant="close-btn" class="btn-container" @click="closeModal">
                    <i class="fas fa-times"></i>
                </b-button>
            </div>
        </template>

        <b-container>
        <div v-if="!loading" class="d-flex justify-content-end align-items-center gap-2">
          <button @click.prevent="downloadHealthQuestion" class="btn univ-btn sendBtn mb-0 mt-0 w-auto ps-4 pe-4 align-items-center">
                <i class="fas fa-download" />
            Download
          </button>
        </div>
            <div class="notes-list-container">
                <div v-if="loading" class="d-flex justify-content-center align-items-center">
                    <b-spinner variant="primary" label="Spinning" />
                </div>
                <div v-if="!loading && health_questions.length === 0"
                    class="d-flex justify-content-center align-items-center">
                    No health questionnaires found
                </div>
                <div v-else>
                    <div v-for="(question, index) in health_questions" :key="index">
                        <div class="split-list">
                            <p v-html="question.question" />
                            <div class="split-yn-div">
                                <div class="form-check form-check-inline">
                                    <input type="radio" :name="`question-${question.question_id}-select-${index}`"
                                        :id="`question-${question.question_id}-select-${index}`" class="form-check-input" :checked="question.selectedAnswer == 1"
                                        :value="1" disabled />
                                    <label class="form-check-label">Yes</label>


                                </div>
                                <div class="form-check form-check-inline">
                                    <input type="radio" :name="`question-${question.question_id}-unselect-${index}`"
                                        :id="`question-${question.question_id}-unselect-${index}`" class="form-check-input"
                                        :checked="question.selectedAnswer == 0" :value="0" disabled />
                                    <label class="form-check-label">No</label>
                                </div>

                                <template v-if="question.selectedAnswer == 1">
                                    <div class="table-responsive" v-if="question.medConditions.length > 0">
                                        <table class="table table-bordered mt-3">
                                            <thead>
                                                <tr>
                                                    <th>Condition/Disease/ Diagnosis/Treatment</th>
                                                    <th>Date of Onset (MM/DD/YYYY)</th>
                                                    <th>Date of Recovery (MM/DD/YYYY)</th>
                                                    <th>Current Treatment</th>
                                                    <th>Taking Medication</th>
                                                    <th>Date Last Seen By Physician (MM/DD/YYYY)</th>
                                                    <th>Remaining Symptoms or Problems? Surgery or Hospitalization?</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-if="question.medConditions.length === 0">
                                                    <tr>
                                                        <td colspan="7" class="text-center">No Data found</td>
                                                    </tr>
                                                </template>
                                                <template v-else>
                                                    <tr  v-for="(condition, condIndex) in question.medConditions" :key="condIndex">
                                                    <td>{{ condition.health_condition || 'N/A' }}</td>
                                                    <td>{{ condition.date_of_onset || 'N/A' }}</td>
                                                    <td>{{ condition.date_of_recovery || 'N/A' }}</td>
                                                    <td>{{ stringifyAnswer(condition.is_treatment) }}</td>
                                                    <td>{{ stringifyAnswer(condition.is_medicate) }}</td>
                                                    <td>{{ condition.d_last_seen || 'N/A' }}</td>
                                                    <td>{{ condition.symptoms || 'N/A' }}</td>
                                                </tr>
                                            </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <template v-if="health_questions.length > 0">
                        <div >
                            <p>Additional Notes</p>
                            <textarea v-model="health_questions[0].additionalNotes" class="form-control" disabled ></textarea>
                        </div>
                    </template>
                </div>
            </div>
        </b-container>
    </b-modal>
</template>

<script>

import axios from "axios";

export default {
    name: "ViewHealthQuestionnairesModal",
    model: {
        prop: 'value',
        event: 'input'
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        member: {
            type: Object,
            default: () => ({} || null)
        },
    },
    data() {
        return {
            health_questions: [],
            loading: false
        };
    },
    computed: {
        isVisible: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    watch: {
        member() {
            this.getHealthQuestions(this.member.policy_id);
        }
    },
    methods: {
     async downloadHealthQuestion() {
      let loader = this.$loading.show();
      const baseURL=process.env.VUE_APP_BASE_API_URL;
      const url = baseURL+"download-health-question?policy_id=" + this.member.policy_id;
      try {
        window.location.href=url;
      } catch (err) {
        this.$notify(
          err?.response?.data?.message || "something went wrong",
          "error"
        );
      } finally {
        loader.hide();
      }
    },
        closeModal() {
            this.isVisible = false;
            this.$emit('close');
            this.health_questions = [];
        },
        handleClose() {
            this.isVisible = false;
            this.$emit('close');
            this.health_questions = [];
        },
        getHealthQuestions(policy_id) {

            let loader = this.$loading.show();
            this.loading = true;

            let xaxios = axios;
            xaxios.get(`v2/get-policy-report/${policy_id}`).then((res) => {
                let { userInfoDepMedBex } = res.data.data;
                this.health_questions = userInfoDepMedBex;
            }).catch((err) => {
                console.log(err)
            }).finally(() => {
                loader.hide();
                this.loading = false;
            })
        },
        stringifyAnswer(value) {
            if (value === 1 || value === '1') return 'Yes';
            if (value === 0 || value === '0') return 'No';
            return 'N/A';
        }
    },
};
</script>

<style scoped>
.notes-scrollable {
    max-height: 400px;
    overflow-y: auto;
    padding-right: 5px;
}

.note-item {
    background-color: #f8f9fa;
    display: flex;
    flex-direction: column;
}

.note-item:last-child {
    margin-bottom: 0;
}

.note-content {
    white-space: pre-wrap;
    font-size: 0.95rem;
    margin-top: 1rem;
}

.note-meta div {
    line-height: 1.2;
}

.note-attachment a {
    color: #03c3ec;
    text-decoration: none;
    font-size: 0.9rem;
}

.note-attachment a:hover {
    text-decoration: underline;
}

.split-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 1.5rem;
    word-break: break-word;
}

.split-yn-div {
    margin-top: 0.5rem;
    width: 100%;
    justify-content: space-between;
    align-items: flex-start;
}

.table-responsive {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    margin-top: 1rem;
    border-radius: 4px;
}

table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 0.9rem;
    margin-bottom: 0;
    border: 1px solid #dee2e6;
}

th, td {
    padding: 0.75rem;
    vertical-align: top;
    border-right: 1px solid #dee2e6;
    border-bottom: 1px solid #dee2e6;
    white-space: nowrap;
}

th {
    background-color: #f8f9fa;
    font-weight: 600;
    white-space: nowrap;
    border-top: 1px solid #dee2e6;
}

th:first-child,
td:first-child {
    border-left: 1px solid #dee2e6;
}

tr:first-child th {
    border-top: none;
}

@media (max-width: 768px) {
    th, td {
        white-space: nowrap;
    }
}
</style>
